<template>
  <div class="mx-6 my-6">
    <div class="flex flex-col border border-gray-300 rounded-lg overflow-hidden bg-white shadow-sm">
      <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex flex-wrap items-center justify-between gap-2">
        <h2 class="text-lg font-medium text-gray-900">YouTube-Videos</h2>
        <button type="button" @click="showForm = true; editingVideo = null" class="inline-flex items-center rounded-md border border-transparent bg-pink-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-pink-700">
          Video hinzufügen
        </button>
      </div>
      <div v-if="showForm" class="p-4 border-b border-gray-200 bg-white">
        <form @submit.prevent="saveVideo" class="space-y-3 max-w-xl">
          <div>
            <label class="block text-sm font-medium text-gray-700">YouTube-URL oder Video-ID</label>
            <input v-model="form.youtubeUrl" type="text" required class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm" placeholder="https://www.youtube.com/watch?v=..." />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Titel</label>
            <input v-model="form.title" type="text" class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm" placeholder="Titel des Videos" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Beschreibung (optional)</label>
            <textarea v-model="form.description" rows="2" class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"></textarea>
          </div>
          <div class="flex gap-2">
            <button type="submit" class="rounded-md bg-pink-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-pink-700">{{ editingVideo ? 'Aktualisieren' : 'Speichern' }}</button>
            <button type="button" @click="showForm = false; editingVideo = null; resetForm()" class="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">Abbrechen</button>
          </div>
        </form>
      </div>
      <div class="divide-y divide-gray-200">
        <div v-for="v in videos" :key="v._id" class="flex flex-wrap items-center gap-4 p-4 hover:bg-gray-50">
          <div class="flex-shrink-0 w-[120px] h-[68px] bg-gray-200 rounded overflow-hidden">
            <img :src="'https://img.youtube.com/vi/' + v.youtubeId + '/mqdefault.jpg'" :alt="v.title" class="w-full h-full object-cover" />
          </div>
          <div class="flex-grow min-w-0">
            <div class="font-medium text-gray-900">{{ v.title || 'Ohne Titel' }}</div>
            <div v-if="v.description" class="text-sm text-gray-500 truncate">{{ v.description }}</div>
            <span :class="v.active ? 'text-emerald-600' : 'text-gray-400'" class="text-xs">{{ v.active ? 'Sichtbar' : 'Ausgeblendet' }}</span>
          </div>
          <div class="flex gap-2">
            <button type="button" @click="startEdit(v)" class="text-sm text-blue-600 hover:underline">Bearbeiten</button>
            <button type="button" @click="removeVideo(v._id)" class="text-sm text-rose-600 hover:underline">Löschen</button>
          </div>
        </div>
        <div v-if="videos.length === 0 && !showForm" class="p-8 text-center text-gray-500">Noch keine Videos. Füge ein YouTube-Video hinzu.</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VideoManager',
  data() {
    return {
      videos: [],
      showForm: false,
      editingVideo: null,
      form: {
        youtubeUrl: '',
        title: '',
        description: ''
      }
    };
  },
  methods: {
    resetForm() {
      this.form = { youtubeUrl: '', title: '', description: '' };
    },
    loadVideos() {
      axios.get('/api/videos?active=false').then(res => { this.videos = res.data; }).catch(() => {});
    },
    startEdit(v) {
      this.editingVideo = v;
      this.form = {
        youtubeUrl: 'https://www.youtube.com/watch?v=' + v.youtubeId,
        title: v.title,
        description: v.description || ''
      };
      this.showForm = true;
    },
    saveVideo() {
      const payload = this.editingVideo
        ? { _id: this.editingVideo._id, title: this.form.title, description: this.form.description, youtubeUrl: this.form.youtubeUrl }
        : { youtubeUrl: this.form.youtubeUrl, title: this.form.title, description: this.form.description };
      const url = this.editingVideo ? '/api/videos/update' : '/api/videos';
      const method = 'post';
      axios[method](url, payload)
        .then(() => {
          this.loadVideos();
          this.showForm = false;
          this.editingVideo = null;
          this.resetForm();
        })
        .catch(() => {});
    },
    removeVideo(id) {
      if (!window.confirm('Video wirklich löschen?')) return;
      axios.post('/api/videos/delete', { id }).then(() => this.loadVideos()).catch(() => {});
    }
  },
  mounted() {
    this.loadVideos();
  }
};
</script>
